import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog"
import Draggable from "react-draggable";
import moment from "moment";

import { fetchNotificationMessages, updateNotifications } from "../../../services/redux/reducers/adminNotificationMessages/adminNotificationMessages";
import { updateNotificationById } from "../../../services/api/adminNotificationMessage";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import Button from "../../../helpers/Button";

import "./index.css";
import { getFullName } from "../../../utils";


const DraggableMessages = () => {
    const [editNotificationId, setEditNotificationId] = useState(null)
    const [editedComment, setEditedComment] = useState("")

    const dispatch = useDispatch()

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyUsers = useSelector((state) => state.userDetails.PMCompanyDetails.companyUsers)
    const notifications = useSelector((state) => state.emergencyMessages.notifications)
    const status = useSelector((state) => state.common.status)

    useEffect(() => {
        const searchParams = {
            statusIds: [17, 18, 4],
            userIds: [userDetails.userId],
            paginator: false
        }
        dispatch(fetchNotificationMessages(searchParams))
    }, [])

    const handleStatusChange = async (notificationId, statusId) => {
        try {
            const data = {
                statusId: statusId
            }

            const notificationRes = await updateNotificationById(notificationId, data)
            if (notificationRes.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: notificationRes.data.error }))
            } else {
                let updatedNotifications = JSON.parse(JSON.stringify(notifications))
                updatedNotifications = updatedNotifications.map(eachNotification => {
                    if (eachNotification.notificationId === notificationId) {
                        eachNotification.statusId = data.statusId
                    }
                    return eachNotification
                })
                dispatch(updateNotifications(updatedNotifications))
            }
        } catch (error) {
            console.error("Error updating message status", error)
        }
    }

    const handleResolveNotification = (notificationId, statusId) => {
        confirmDialog({
            message: 'Confirm to mark this message as resolved?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => handleStatusChange(notificationId, statusId)
        })
    }

    const handleEditComment = (notificationId, currentComment) => {
        setEditNotificationId(notificationId)
        setEditedComment(currentComment || "")
    }

    const handleSaveComment = async (notificationId) => {
        const data = {
            comment: editedComment
        }
        const notificationRes = await updateNotificationById(notificationId, data)

        if (notificationRes.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: notificationRes.data.error }))
        } else {
            let updatedNotifications = JSON.parse(JSON.stringify(notifications))
            updatedNotifications = [...updatedNotifications]
            updatedNotifications = updatedNotifications.map(eachNotification => {
                if(eachNotification.notificationId === notificationId){
                    eachNotification.comment = editedComment
                }
                return eachNotification
            })
            dispatch(updateNotifications(updatedNotifications))
        }
        setEditNotificationId(null)
    }

    return (
        <div className="draggable-message-container">
            {
                notifications.map(message => {
                    const relatedUserDetails = pmCompanyUsers.find(eachUser => eachUser.userId === message.userId)
                    const relatedStatus = status.find(eachStatus => eachStatus.statusId === message.statusId)

                    return (
                        <Draggable key={message.notificationId}>
                            <div className={`message-popup ${relatedStatus?.status}`}>
                                <div>
                                    <div className="message-title-priority-box" style={{ display: "flex", justifyContent: "space-between" }}>
                                        <h5 className="" style={{ fontSize: "14px"}}>{message.message}</h5>
                                        <div className="icon-box">
                                            {message.priority === "high" && (
                                                <i className="pi pi-exclamation-circle" style={{ color: "red", fontSize: "1.2rem" }} />
                                            )}
                                            {message.priority === "medium" && (
                                                <i className="pi pi-exclamation-circle" style={{ color: "blue", fontSize: "1.2rem" }} />
                                            )}
                                            {message.priority === "low" && (
                                                <i className="pi pi-exclamation-circle" style={{ color: "green", fontSize: "1.2rem" }} />
                                            )}
                                        </div>

                                    </div>
                                    <div className="my-1" style={{ color: "grey", fontSize: "12px"}}>
                                        {getFullName(relatedUserDetails?.firstName, relatedUserDetails?.lastName)} on {moment(message.createdAt).format('DD MMM h:mm A')}
                                    </div>
                                </div>

                                {editNotificationId === message.notificationId ?
                                    <div>
                                        <textarea
                                            value={editedComment}
                                            onChange={(e) => setEditedComment(e.target.value)}
                                            rows="2"
                                            style={{ background:"transparent", borderRadius: "4px",padding: "5px", fontSize:"12px", width: "100%"}}
                                        />
                                        <div className="flex flex-row justify-content-end">
                                            <Button icon="pi pi-save" className="comment-btn mt-1" onClick={() => handleSaveComment(message.notificationId)}></Button>
                                            <Button icon="pi pi-times" className="cancel-btn mt-1" onClick={() => setEditNotificationId(null)}></Button>
                                        </div>
                                    </div>
                                    :
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <h6 className="mb-1" style={{ fontSize: "12px"}}>{message.comment || "No comment available."}</h6>
                                        <i className="pi pi-pencil" style={{ color: "black", fontSize: "0.8rem", cursor: "pointer" }} onClick={() => handleEditComment(message.notificationId, message.comment)} />
                                    </div>
                                }

                                {message.statusId == 17 && 
                                    <button className="button-on-message-card on-it-btn" onClick={() => handleStatusChange(message.notificationId, 18)}>
                                        I'm on it
                                    </button>
                                }

                                {message.statusId != 4 && 
                                    <button className="button-on-message-card mark-pending-btn" onClick={() => handleResolveNotification(message.notificationId, 4)}>
                                        Mark Resolved
                                    </button>
                                }

                                {
                                    message.statusId == 4 && (
                                        <span style={{fontSize: "13px", margintTop: "3px" }}> <i className="pi pi-info-circle" style={{ fontSize: "0.8rem" }} /> Dismiss Pending </span>
                                    )
                                }
                            </div>
                        </Draggable>
                    )
                })
            }
        </div>
    )
}

export default DraggableMessages;